// Constantes con los colores definidos de la paleta de colores de los modos osuro y claro.

export const dark = {
    bg:" #13222B",
    bg_inbox_dark_mode: "#202C33",
    bg_chat_dark_mode: "#0B141A",
    bg_searcher_dark_mode: "#4B5563",
    bg_hover_dark_mode: "#13222B",
    bg_border_dark_mode: "#374248",
    bg_border_dark_ligth_mode: "#202C33",
    bg_text_inbox_dark_mode: "#ffffff",
    bg_chat_bg_dark_mode: "#13222B",
    bg_session_duration_dark_mode: "#202C33",
    bg_session_inCourse_dark_mode: "#ffffff",

}

export const ligth = {
    bg:" #ffffff",
    bg_inbox_ligth_mode: "#ffffff",
    bg_chat_ligth_mode: "#0B141A",
    bg_searcher_ligth_mode: "#E4E4E7",
    bg_hover_ligth_mode: "rgb(241, 241, 241)",
    bg_border_ligth_mode: "#E4E4E7",
    bg_border_ligth_ligth_mode: "#f7f7f7",
    bg_text_inbox_ligth_mode: "#000000",
    bg_chat_bg_ligth_mode: "rgb(var(--message-r), var(--message-g), var(--message-b), .05)",
    bg_session_duration_ligth_mode: "#fff4df",
    bg_session_inCourse_ligth_mode: "#506a9e",
}
